export default __webpack_public_path__ + "f218a60898356114862a2cba3ce005a1.png";